
























































































import { Component, Vue } from 'vue-property-decorator'
import SearchForm from '@/components/common/SearchForm.vue'
import TableForm from '@/components/common/TableForm.vue'
import ThreePartDialog from './ThreePartDialog.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { translate } from '@/utils/filters'
import { Form } from 'element-ui'
import store from '@/store'

@Component({
    components: {
        SearchForm,
        TableForm,
        ThreePartDialog
    }
})
export default class ThreePart extends Vue {
    formEl: any
    searchForm = {
        current: 1,
        size: 10,
        paymentType: null,
        channelId: null
    }

    paymentTypeList = []
    channelList = []

    tableLoading = false
    tableData = []
    total = 0

    show = false
    isEdit = false
    activeRow: any = {}
    formData = {
        paymentType: '',
        channelId: '',
        key: '',
        value: ''
    }
    rules = {
        paymentType: {
            required: true,
            message: translate('returnCode.channelNoNull'),
            trigger: 'change'
        },
        channelId: {
            required: true,
            message: translate('returnCode.paymentTypeNoNull'),
            trigger: 'change'
        },
        key: {
            required: true,
            message: translate('base.three.part.rules.key'),
            trigger: 'change'
        }
    }
    onEditDialogClose(done) {
        ;(this.$refs.dvp as Form).resetFields()
        done()
    }

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    onAddBlock() {
        this.searchForm.current = 1
        this.getData()
    }

    create() {
        this.show = true
    }

    modify(row: any) {
        this.isEdit = true
        this.activeRow = { ...row }
        // Display information in the form
        this.formData.paymentType = row.paymentType
        this.formData.channelId = row.channelId
        this.formData.key = row.key
        this.formData.value = row.value
    }

    /** 保存列表某条数据的修改 */
    save() {
        let params = {
            merchantId: store.getters.tenantId,
            id: this.activeRow.id,
            channelId: this.formData.channelId,
            paymentType: this.formData.paymentType,
            key: this.formData.key,
            value: this.formData.value
        }

        $Api.channelService.updateAbroadThirdParameter(params).subscribe(data => {
            this.isEdit = false
            this.$message.success('Success!')
            this.getData()
        })
    }

    // 删除
    del(row: any) {
        this.showDialog(this.$t('common.isDelete') as string, () => {
            $Api.channelService.deleteAbroadThirdParameter({ id: row.id }).subscribe(data => {
                this.$message.success('Success!')
                this.getData()
            })
        })
    }

    // 弹出提示框
    showDialog(title: string, callback: Function) {
        this.$confirm(title, {
            confirmButtonText: this.$t('common.btn.confirm') as string,
            cancelButtonText: this.$t('common.btn.cancel') as string,
            type: 'warning'
        })
            .then(() => {
                callback()
            })
            .catch(() => {})
    }

    getData(pageQuery = {}) {
        this.tableLoading = true
        $Api.channelService
            .abroadThirdParameterList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    queryPaymentTypes() {
        $Api.channelService.queryPaymentTypeList().subscribe((data: any) => {
            this.paymentTypeList = data
        })
    }

    queryChannels() {
        $Api.channelService.queryChannelDropdown().subscribe((data: any) => {
            this.channelList = data
        })
    }

    mounted() {
        this.getData()
        this.queryPaymentTypes()
        this.queryChannels()
    }
}
